export const NombreMensajeAlertas = {
    SOLICITUD_CREACION_INVALIDA: "solicitud-creacion-invalida",
    SOLICITUD_CLAVE_CORRECTO: "solicitud-clave-correcto",
    PRESTADOR_CONSULTA_NOFOUND: "prestador-consulta-nofound",
    SOLICITUD_CANCELAR_CONFIRMACION: "solicitud-cancelar-confirmacion",
    SOLICITUD_CANCELAR_MSG: "solicitud-cancelar-msg",
    SOLICITUD_CREAR_CONFIRMACION: "solicitud-crear-confirmacion",
    SOLICITUD_CREAR_CORRECTO: "solicitud-crear-correcto",
    LiMITE_RANGO_FECHA_SOLICITUDES: "limite-rango-fecha-solicitudes",
    SOLICITUD_CAMPO_AFILIADO_INFORMACION: "solicitud-campo-afiliado-informacion",
    SOLICITUD_CAMPO_TIPO_REEMBOLSO_INFORMACION: "solicitud-campo-tipo-reembolso-informacion",
    SOLICITUD_CAMPO_FECHA_SERVICIO_INFORMACION: "solicitud-campo-fecha-servicio-informacion",
    SOLICITUD_CAMPO_MONTO_INFORMACION: "solicitud-campo-monto-informacion",
    SOLICITUD_INFO_BANCO_INFORMACION: "solicitud-info-banco-informacion",
    SOLICITUD_CAMPO_MOTIVO_INFORMACION: "solicitud-campo-motivo-informacion"
}